export default __webpack_public_path__ + "static/media/arrow_up.f3ed3ed8.svg";